export default __webpack_public_path__ + "static/mobile-banner-d3f41d05f253bbc17e6df8e2895067d6.png";